import { useLocation } from 'react-router-dom';

import { DateHelper } from '@utils/DateHelper';

import type { PageSize } from '@components';

type Props = {
  pageSizeList: PageSize[];
};

export function useQueryParams({ pageSizeList }: Props) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const startAt = searchParams.get('startAt');
  const endAt = searchParams.get('endAt');
  const page = Number(searchParams.get('page'));
  const pageSize = Number(searchParams.get('pageSize'));

  const isValidStartDate = new DateHelper().validate(startAt);
  const isValidEndDate = new DateHelper().validate(endAt);
  const isValidPage = page === 0 || Number.isInteger(page);
  const isValidPageSize =
    pageSize === 0 ||
    (Number.isInteger(pageSize) && pageSizeList.find(({ value }) => value === pageSize));

  const isInValidQueryParams =
    !isValidStartDate || !isValidEndDate || !isValidPage || !isValidPageSize;

  if (isInValidQueryParams) {
    return {
      startAt,
      endAt,
      page,
      pageSize,
      pageSizeList,
      isInValidQueryParams
    };
  }

  return {
    startAt,
    endAt,
    page,
    pageSize,
    pageSizeList,
    isInValidQueryParams
  };
}
